import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { BeforeAfterDTO, ProgressInsightsDTO, StreakDTO } from '../types/dtos';

/**
 * Domínio "progresso" — só leitura aqui; quem invalida são os services que
 * mudam logs/rotinas (executar rotina, criar/excluir registro).
 */
export const CHAVES_PROGRESSO = {
  dominio: ['progresso'] as const,
  streak: (userId: string) => ['progresso', 'streak', userId] as const,
  insights: (userId: string) => ['progresso', 'insights', userId] as const,
  antesDepois: (userId: string, days: number) => ['progresso', 'antes-depois', userId, days] as const,
};

const ProgressService = {
  // GET /api/v1/users/{userId}/progress/before-after?days=N → BeforeAfterDTO
  // O backend escolhe o par: "depois" = foto mais recente; "antes" = foto mais próxima de N dias atrás.
  getBeforeAfter: (userId: string, days: number): Promise<AxiosResponse<BeforeAfterDTO>> =>
    api.get(`/users/${userId}/progress/before-after`, { params: { days } }),

  // GET /api/v1/users/{userId}/progress/streak → StreakDTO
  // Sequência de dias com rotina, recorde, semana corrente e visão geral do mês.
  getStreak: (userId: string): Promise<AxiosResponse<StreakDTO>> =>
    api.get(`/users/${userId}/progress/streak`),

  // GET /api/v1/users/{userId}/progress/insights → ProgressInsightsDTO
  // Métricas aproximadas por IA (primeira vs. última foto) + ajuste sugerido. Cacheado no backend.
  getInsights: (userId: string): Promise<AxiosResponse<ProgressInsightsDTO>> =>
    api.get(`/users/${userId}/progress/insights`),
};

export default ProgressService;
